export default {
  FILTER_APPROVAL_REQUEST_LIST: 'FilterApprovalRequestList',
  LOAD_APPROVAL_REQUEST_LIST_START: 'LoadApprovalRequestListStart',
  LOAD_APPROVAL_REQUEST_LIST_END: 'LoadApprovalRequestListEnd'
};